import React from 'react'
import StraitsXBreadcrumbBar from '~/components/StraitsXBreadcrumbBar'

function withStraitsXBreadcrumbBar(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  WrappedComponent: React.ComponentType<any>
) {
  return class extends React.Component {
    render() {
      return (
        <>
          <StraitsXBreadcrumbBar {...this.props} />
          <WrappedComponent {...this.props} />
        </>
      )
    }
  }
}

export default withStraitsXBreadcrumbBar
